import PropTypes from "prop-types";
import { classNamePropType } from "../../common";

/**
 * PropTypes for AppHeader component
 *
 * @property {string} [className] - Additional CSS classes
 * @property {React.ReactNode} [logo] - Logo element
 * @property {React.ReactNode} [children] - Header content
 * @property {function} [onMenuClick] - Menu button click handler (for mobile)
 */
export const appHeaderPropTypes = {
  className: classNamePropType,
  logo: PropTypes.node,
  children: PropTypes.node,
  onMenuClick: PropTypes.func,
};
